/**
 * Time & Attendance — My Day (Dashboard) quick start.
 */

export const PEOPLE_MY_DAY_TOUR_ID = "people-my-day-v1";

export const PEOPLE_MY_DAY_TOUR_STEPS = [
  {
    id: "masthead",
    route: "/people/my-day",
    selector: "[data-tour='myday-masthead']",
    title: "Your duty board",
    description:
      "My Day is your Time & Attendance home. See today’s date, timesheet status, and the next action you should take.",
    placement: "bottom",
  },
  {
    id: "time",
    route: "/people/my-day",
    selector: "[data-tour='myday-time']",
    title: "Today’s hours",
    description:
      "Charge hours logged for today appear here. Open Time to add or edit entries as you work — you do not have to wait until 4:00 PM.",
    placement: "right",
  },
  {
    id: "next",
    route: "/people/my-day",
    selector: "[data-tour='myday-next']",
    title: "What needs attention",
    description:
      "Missed weekday logs, certifications due, and other follow-ups show in this queue so you know what to clear first.",
    placement: "left",
  },
  {
    id: "leave",
    route: "/people/my-day",
    selector: "[data-tour='myday-leave']",
    title: "Leave at a glance",
    description:
      "Quick view of your leave balances. Use the Leave tab to request time off or check booked dates.",
    placement: "top",
  },
];
